import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HttpCancelService {
  private cancelPendingRequests$ = new Subject<boolean>();

  public cancelPendingRequests(forceCancellation = false): void {
    this.cancelPendingRequests$.next(forceCancellation);
  }

  public onCancelPendingRequests(): Observable<boolean> {
    return this.cancelPendingRequests$.asObservable();
  }
}
